/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Demands_SubtitleInputs */

const cs_demands_subtitle = /** @type {(inputs: Demands_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Poptávky klientů — lokalita, rozpočet, typ — a shody s inzeráty.`)
};

const en_demands_subtitle = /** @type {(inputs: Demands_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Client search intents — locality, budget, type — and listing matches.`)
};

/**
* | output |
* | --- |
* | "Client search intents — locality, budget, type — and listing matches." |
*
* @param {Demands_SubtitleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const demands_subtitle = /** @type {((inputs?: Demands_SubtitleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Demands_SubtitleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_demands_subtitle(inputs)
	return cs_demands_subtitle(inputs)
});